import BigWidthChildren from './component'

export default BigWidthChildren
